import { inheritSerialization } from 'cerialize';
import { AbstractType } from './abstract-type';

@inheritSerialization(AbstractType)
export class FareReviewTriggerType extends AbstractType {}
